import React, { useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";

type OwnProps = {
  showModal: boolean;
  onConfirm: () => any;
  onHide: () => any;
  isLoading: boolean;
};

type Props = OwnProps;

const UnsaveConfirmModal = (props: Props) => {
  useEffect(() => {
    if (props.showModal && !props.isLoading) {
      props.onHide();
    }
  }, [props.isLoading]);

  const handleConfirm = () => {
    if (!props.isLoading) {
      props.onConfirm();
    }
  };

  return (
    <Modal
      show={props.showModal}
      onHide={props.onHide}
      animation={false}
      centered
      backdropClassName="customDarkModalBackdrop in"
    >
      <Modal.Header
        closeButton
        className={`purpleModalHeader font-weight-bold`}
      >
        <Modal.Title>Discard Group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <p className="font-weight-bold">Are you sure you want to discard this group?</p>
          <p>The group will be removed from your teacher’s list and moved to Recommendations.</p>
        </div>
        <hr />
        <div className="d-flex justify-content-between">
          <button
            className="whiteBtnSm"
            disabled={props.isLoading}
            onClick={props.onHide}
          >
            Cancel
          </button>
          <button className="blueBtnSm" onClick={handleConfirm}>
            Yes, Discard{" "}
            {props.isLoading && <Spinner animation="border" size="sm" />}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UnsaveConfirmModal;
